import { render, staticRenderFns } from "./ExcursionSubscriptions.vue?vue&type=template&id=4f3f60e5&scoped=true"
import script from "./ExcursionSubscriptions.vue?vue&type=script&lang=ts"
export * from "./ExcursionSubscriptions.vue?vue&type=script&lang=ts"
import style0 from "./ExcursionSubscriptions.vue?vue&type=style&index=0&id=4f3f60e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3f60e5",
  null
  
)

export default component.exports